import { PlayerSide } from "../ai/TableAI";

export function GetOppositePlayerSide(side:PlayerSide): PlayerSide
{
    if(side == PlayerSide.US) {
        return PlayerSide.THEM;
    }
    return PlayerSide.US;
}